import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Index";
import Custodians from "./Pages/Custodians/Index";
import TransactionsManagement from "./Pages/Transaction/Index";
import Strategies from "./Pages/Strategy/Index";
import StrategyPerformance from "./Pages/StrategyPerformance/Index";
import UserStatusManagement from "./Pages/UserStatus";
import CustodianManagement from "./Pages/CustodianManagement";
import { useSelector, useDispatch } from "react-redux";
import { addToken } from "./redux/Reducers/authReducer";
import PrivateRoute from "./PrivateRoute";
import Loader from "./Loader";
import UserManagerManagement from "./Pages/ManagerManagement";
import ModifyUserDetails from "./Pages/UserDetails";
import AddAssets from './Pages/AddAsset'
import MainKyc from "./Pages/KycManagement";
import AddSubAdmin from './Pages/AddSubAdmins'
import ActivityLogs from "./Pages/ActivityLogs/index";
import ActivityMonitor from './Components/ActivityMonitor';
import SubRoleManagement from './Pages/SubRoleManagement';
import ProfileSettings from "./Pages/ProfileSettings";

function AllRoutes() {
  const { token, loading } = useSelector((state) => state.user);
  const [isTokenChecked, setIsTokenChecked] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(addToken());
    setIsTokenChecked(true);
  }, [dispatch]);

  if (!isTokenChecked || loading) {
    return <Loader />;
  }

  return (
    <>
      <BrowserRouter>
        {loading && <Loader />}
        <ActivityMonitor />
        <Routes>
          {!token ? (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" replace />} />{" "}
            </>
          ) : (
            <>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile-settings/:tab"
                element={
                  <PrivateRoute>
                    <ProfileSettings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile-settings"
                element={<Navigate to="/profile-settings/account" replace />}
              />
              <Route
                path="/custodians"
                element={
                  <PrivateRoute>
                    <Custodians />
                  </PrivateRoute>
                }
              />
              <Route
                path="/transactions"
                element={
                  <PrivateRoute>
                    <TransactionsManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/user_status"
                element={
                  <PrivateRoute>
                    <UserStatusManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/manager"
                element={
                  <PrivateRoute>
                    <UserManagerManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/user/:id"
                element={
                  <PrivateRoute>
                    <ModifyUserDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/assets/:id"
                element={
                  <PrivateRoute>
                    <AddAssets />
                  </PrivateRoute>
                }
              />
              <Route
                path="/strategies"
                element={
                  <PrivateRoute>
                    <Strategies />
                  </PrivateRoute>
                }
              />
              <Route
                path="/performance/:id"
                element={
                  <PrivateRoute>
                    <StrategyPerformance />
                  </PrivateRoute>
                }
              />
              <Route
                path="/custodian/:custodianValue"
                element={
                  <PrivateRoute>
                    <CustodianManagement />
                  </PrivateRoute>
                }
              />
               <Route
                path="/createkyc"
                element={
                  <PrivateRoute>
                    <MainKyc />
                  </PrivateRoute>
                }
              />

               <Route
                path="/createadmin"
                element={
                  <PrivateRoute>
                    <AddSubAdmin />
                  </PrivateRoute>
                }
              />

               <Route
                path="/activity"
                element={
                  <PrivateRoute>
                    <ActivityLogs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/subrole-management"
                element={
                  <PrivateRoute>
                    <SubRoleManagement />
                  </PrivateRoute>
                }
              />
            </>
          )}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default AllRoutes;
